import React from "react";
import { connect } from "react-redux";
import QuestionSets from "../../../libs/QuestionSets";

import "./Nav2.scss";

const Nav2 = (props) => {
  // props.questions.push('extra');

  const questionLen = QuestionSets[props.currentRole].length;

  const questions = [...props.currentQuestions];

  questions.push("extra");

  return (
      //ACC
    <aside className="Nav2__wrapper">
      <div className="Nav2__items">
        {questions.map((question, i) => {
          let retThis;

          if (i === 0) {
            retThis = (
              <div
             
                className="Nav2__item Nav2__item-init Nav2__item-activate"
                key={`Nav2__item${i}`}
              >
                <div className="Nav2__item--line"></div>
                <div className="Nav2__item--text" >{`0${i + 1}`}</div>
              </div>
            );
          } else {
            retThis = (
              <div
                className={`Nav2__item Nav2__item--${i}`}
                key={`Nav2__item${i}`}
              >
                <div className="Nav2__item--line Nav2__item--line"></div>
                <div className="Nav2__item--text">
                  {i !== questionLen ? `0${i + 1}` : ""}
                </div>
              </div>
            );
          }

          return retThis;
        })}
      </div>
    </aside>
  );
};

export default connect(mapStateToProps, null)(Nav2);

function mapStateToProps(state) {
  return {
    currentRole: state.roleReducer.currentRole,
    currentQuestions: state.questionsReducer.currentQuestions,
  };
}
